import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsksuiteCitrusModule } from 'asksuite-citrus';
import { TranslateModule } from '@ngx-translate/core';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-token-refresh-modal',
  standalone: true,
  imports: [CommonModule, AsksuiteCitrusModule, TranslateModule],
  templateUrl: './token-refresh-modal.component.html',
  styleUrls: ['./token-refresh-modal.component.scss'],
})
export class TokenRefreshModalComponent implements OnInit {
  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    this.redirect();
  }

  redirect(): void {
    this.sessionService.exit();
  }
}
